<template>
<div>
  <div class="row">
    <div class="col-6 col-lg-3">
      <ul class="list spaced-list font-weight-bold p-0">
        <li><h3>Transação</h3></li>
        <li>
          <p>CPF</p>
        </li>
        <li v-if="idCheck && idCheck.reason.birthday">
          <p>Data de nascimento (SERPRO)</p>
        </li>
        <li v-if="backCheck">
          <p>Data de nascimento (SPC)</p>
        </li>
        <li v-if="facebook.birthday">
          <p>Data de Nascimento (Facebook)</p>
        </li>
        <li>
          <p>Rating</p>
        </li>
        <li>
          <p>Loja</p>
        </li>
        <li v-if="sellerStatus !== undefined">
          <p>Status</p>
        </li>
        <li>
          <p>Data de criação</p>
        </li>
      </ul>
    </div>
    <div class="col">
      <ul class="list spaced-list p-0">
        <li><h3>#{{ tx.id | numeral('00000') }}</h3></li>
        <li>
          <p>{{ user.cpf }}</p>
        </li>
        <li v-if="idCheck && idCheck.reason.birthday">
          <p>{{ idCheck.reason.birthday.status + (idCheck.reason.birthday.reason ? ' (' + idCheck.reason.birthday.reason + ')' : '') }}</p>
        </li>
        <li v-if="backCheck && backCheck.reason">
          <p v-if="backCheck.reason.spc_check">{{ backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['data-nascimento'] | moment-date }}</p>
          <p v-else-if="backCheck.reason.grade && backCheck.reason.grade.reason.debug['spc-serasa']">{{ backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['data-nascimento'] | moment-date }}</p>
        </li>
        <li v-if="facebook.birthday">
          <p>{{ facebook.birthday ? (facebook.birthday | moment-date) : '' }}</p>
        </li>
        <li>
          <b-badge pill :variant="(rating === 'A' || rating === 'B') ? 'success' : ((rating === 'D' || rating === 'E') ? 'danger' : 'warning')">{{ rating }}</b-badge>
        </li>
        <li>
          <p>{{ tx.sellerName }}</p>
        </li>
        <li v-if="sellerStatus !== undefined">
          <b-badge pill :variant="sellerStatus ? 'success' : 'danger'">{{ sellerStatus ? 'CRIADO' : 'NÃO CRIADO' }}</b-badge>
        </li>
        <li>
          <p>{{ tx.dateCreated | moment-complete }}</p>
        </li>
      </ul>
    </div>
  </div>
</div>
</template>
<script>
export default {
  components: {
  },
  data () {
    return {
    }
  },
  props: ['backCheck', 'idCheck ', 'user', 'rating', 'tx', 'sellerStatus', 'facebook'],
  methods: {
  },
  mounted () {
  },
  watch: {
    '$route.params.txid' () {
    }
  }
}
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/partial/cards/verification/BackgroundCheckNew.vue